import React from 'react';
import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div<{ $size?: number; $color?: string }>`
  width: ${({ $size }) => $size || 40}px;
  height: ${({ $size }) => $size || 40}px;
  border: 3px solid ${({ theme }) => theme.colors.grayScale[20]};
  border-top: 3px solid ${({ $color, theme }) => $color || theme.colors.primaryBlue[40]};
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 200px;
`;

interface DSLoadingProps {
  size?: number;
  color?: string;
}

const DSLoading: React.FC<DSLoadingProps> = ({ size, color }) => {
  return (
    <LoadingWrapper>
      <Spinner $size={size} $color={color} />
    </LoadingWrapper>
  );
};

export default DSLoading;
